import axios from "axios";
import HoldOn from "react-hold-on";
import toast from "react-hot-toast";
import {
  beneficiaryError,
  beneficiarySuccess,
  getBeneficiaryByIdSuccess,
  selectBeneficiary,
  selectBeneficiaryId,
} from "../../Reducer/beneficiary";
import apiUrl from "../../ApiUrl";

export const BeneficiaryCreates = (body, studentId) => async (dispatch) => {
  let options = {
    theme: "sk-cube-grid",
    message: "Creating Beneficiary ...",
    textColor: "pink",
  };
  try {
    HoldOn.open(options);
    const headers = {
      user_id: studentId,
      "Content-Type": "application/json",
    };
    console.log("beneficiary data:", body);

    const response = await axios.post(`${apiUrl}beneficiary`, body, {
      headers,
    });
    console.log("Response of create beneficiary api:", response.data);
    if (response.data) {
      
      await dispatch(getBenificiaryListById(response.data?.beneficiary_id));
      await toast.promise(Promise.resolve(response.data), {
        loading: "Creating Beneficiary...",
        success: <b>Beneficiary created successfully!</b>,
        error: <b>Could not create beneficiary.</b>,
      });
    }
  } catch (error) {
    console.error("Error in beneficiary api:", error);
    toast.error("Error creating beneficiary. Please try again.");
  } finally {
    HoldOn.close();
  }
};

export const getBenificiaryListByStudentId =
  (studentId) => async (dispatch) => {
    let options = {
      theme: "sk-cube-grid",
      message: "Fetching Beneficiary List ...",
    };
    try {
      HoldOn.open(options);
      const headers = {
        "user-id": studentId,
      };
      const config = {
        method: "get",
        url: `${apiUrl}beneficiary/studentId`,
        headers,
      };

      const response = await axios(config);
      console.log("Response of get beneficiary list api:- ", response.data);
      dispatch(beneficiarySuccess(response.data));
      return response.data;

      // You might want to dispatch the response data to the store here
      // dispatch(setBeneficiaryList(response.data));
    } catch (error) {
      console.error("Error in get beneficiary list api:- ", error);
    } finally {
      HoldOn.close();
    }
  };

export const getBenificiaryListById = (beneficiaryId) => async (dispatch) => {
  let options = {
    theme: "sk-cube-grid",
    message: "Fetching Beneficiary Details...",
  };
  try {
    HoldOn.open(options);
    console.log("beneficiary id:", beneficiaryId);

    const headers = {
      "ben-id": beneficiaryId,
      "Content-Type": "application/json",
    };

    const response = await axios.get(`${apiUrl}beneficiary/id`, { headers });

    console.log("Response of get beneficiary by id api:", response.data);

    if (response.data) {
      await dispatch(getBeneficiaryByIdSuccess(response.data));
      await dispatch(selectBeneficiary(beneficiaryId));
      return response.data;
    }
  } catch (error) {
    console.error("Error fetching beneficiary details:", error);
    dispatch(beneficiaryError(error.message));
  } finally {
    HoldOn.close();
  }
};
